import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import { of } from "rxjs";
import { catchError, map, switchMap, withLatestFrom } from "rxjs/operators";

import { MpCommonServiceV2 } from "../../../services/api/mp-common-v2.service";
import { MpCommonActions } from "../../actions/mp-common.actions";
import { FailState } from "../../models/fail-state";
import { VendorsState } from "../../models/mp-common/vendors-state";
import { AppState } from "../../reducers";
import { MpCommonSelectors } from "../../selectors/mp-common.selectors";

@Injectable()
export class VendorsGetEffects {
	get = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.vendors.get),
			withLatestFrom(this.store.select(MpCommonSelectors.vendors)),
			switchMap(([action, state]) =>
				this.canUseStoreValue(action, state)
					? of(MpCommonActions.vendors.getSuccess(state))
					: of(MpCommonActions.vendors.getApi({ params: action.params }))
			)
		)
	);

	getApi = createEffect(() =>
		this.actions.pipe(
			ofType(MpCommonActions.vendors.getApi),
			withLatestFrom(this.store.select(MpCommonSelectors.vendors)),
			switchMap(([action, state]) =>
				this.mpCommonService.activeVendors(action.params).pipe(
					map((vendors) => {
						const allRetrieved = state.allRetrieved || this.noParams(action);
						return MpCommonActions.vendors.getSuccess({
							vendors,
							loading: false,
							allRetrieved
						});
					}),
					catchError((error) => of(MpCommonActions.vendors.getFail(new FailState(error))))
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private store: Store<AppState>,
		private mpCommonService: MpCommonServiceV2
	) {}

	private canUseStoreValue(action, state: VendorsState): boolean {
		const allQuery = this.noParams(action);
		const ids = _.split(_.get(action, "params.id", "noop"), ",");
		const storeIds = _.map(state.vendors, (v) => v.id);
		return !_.has(state, "error") && !state.loading && allQuery
			? state.allRetrieved
			: _.every(ids, (id) => _.includes(storeIds, id));
	}

	private noParams(action): boolean {
		return !action.params || _.keys(action.params).length === 0;
	}
}
